var map = {
	"./certificate_automatic_frame.png": 153,
	"./certificate_ects_frame.png": 154,
	"./certificate_frame.png": 155,
	"./certificate_verified_frame.png": 156,
	"./frame_blue_de.png": 157,
	"./frame_blue_en.png": 158,
	"./frame_gold_de.png": 159,
	"./frame_gold_en.png": 160,
	"./frame_green_de.png": 161,
	"./frame_green_en.png": 162,
	"./generic_audit_sample.jpg": 163,
	"./generic_bundle_sample.jpg": 164,
	"./generic_coa_ects_sample.jpg": 165,
	"./generic_coa_sample.jpg": 166,
	"./generic_sop_sample.jpg": 167,
	"./milestone_completed.png": 168,
	"./milestone_completed.svg": 169,
	"./milestone_completed_small.svg": 170,
	"./milestone_uncompleted.png": 171,
	"./milestone_uncompleted.svg": 172,
	"./milestone_uncompleted_old.png": 173
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 152;